import { useState, createContext } from "react";

export const PrioritizeSlidersContext = createContext<any>(null);

const PrioritizeSlidersProvider = ({ children }: any) => {
  const defaultValues = {
    PPARank: 100,
    LowIncPercRank: 100,
    POCPercRank: 100,
    HeatRank: 100,
    RespRank: 100,
    MentalRank: 100,
    LPARank: 100,
  };
  const [prioritizeSlidersValue, setPrioritizeSlidersValue] =
    useState<any>(defaultValues);

  const [checked, setChecked] = useState<boolean>(false);

  const [hideOtherLayers, setHideOtherLayers] = useState<boolean>(false);

  return (
    <PrioritizeSlidersContext.Provider
      value={{
        prioritizeSlidersValue,
        setPrioritizeSlidersValue,
        checked,
        setChecked,
        hideOtherLayers,
        setHideOtherLayers
      }}
    >
      {children}
    </PrioritizeSlidersContext.Provider>
  );
};

export default PrioritizeSlidersProvider;
